/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { ICreditCardPaymentProfileItem } from 'modules/PaymentProfile/reducers/type';
import { FormHorizontal, ReadOnly } from '@myob/myob-widgets';
import capitalize from 'lodash/capitalize';

const CreditCardPaymentProfile: React.FC<{ paymentItem: ICreditCardPaymentProfileItem }> = ({ paymentItem }) => {
    const getFormattedMonth = (month: string) =>
        Number(month)
            .toString()
            .padStart(2, '0');

    return (
        <FormHorizontal>
            <ReadOnly label="Payment method" name="paymentMethod">
                {capitalize(paymentItem.payment_method)}
            </ReadOnly>
            <ReadOnly label="Payment frequency" name="paymentFrequency">
                {paymentItem.payment_schedule}
            </ReadOnly>
            <ReadOnly label="Cardholder name" name="cardholderName">
                {paymentItem.credit_card.name_on_card}
            </ReadOnly>
            <ReadOnly label="Type" name="type">
                {paymentItem.credit_card.type}
            </ReadOnly>
            <ReadOnly label="Expiry date" name="expiryDate">
                {`${getFormattedMonth(paymentItem.credit_card.expiry_month)}/${paymentItem.credit_card.expiry_year}`}
            </ReadOnly>
        </FormHorizontal>
    );
};

export default CreditCardPaymentProfile;
